"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileNotificationsOptionsOverlay = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var react_redux_1 = require("react-redux");
var Types = require("types");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var sok_ui_1 = require("@caddigital/sok-ui");
require("./styles.scss");
var recompose_1 = require("recompose");
var mapStateToProps = function (state) {
    return {
        user: state.auth.current.user,
        notificationsOptionsOverlayStatus: state.files.notificationsOptionsOverlayStatus,
        currentProject: state.project.currentProject,
        currentFolder: state.files.currentFolder,
        sortByOptions: state.files.sortByOptions,
        searchOptions: state.files.searchOptions
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    save: function (files, status, notificationType) {
        dispatch(FilesActions.toggleNotificationsRequest(files, status, notificationType));
    },
    closeAndClear: function (currentFolderId, sort, search) {
        return function () {
            if (currentFolderId) {
                dispatch(FilesActions.fetchFiles(currentFolderId, sort, search));
            }
            dispatch(FilesActions.closeNotificationsOptionsPaneAction());
        };
    },
    clear: function (selectedItems) { return function () {
        dispatch(FilesActions.closeNotificationsOptionsPaneAction());
        dispatch(FilesActions.unselectFileItems(selectedItems));
    }; },
    toggleEmailNotifications: function (files) {
        return function (state) {
            dispatch(FilesActions.updateFolderNotifications(files, state));
        };
    },
    clearSelections: function (items) {
        return dispatch(FilesActions.unselectFileItems(items));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var reMappedState = function (props) {
    var projectName = props.notificationsOptionsOverlayStatus.type === 'OPEN'
        ? props.notificationsOptionsOverlayStatus.projectName
        : '';
    var projectId = props.currentProject.status === 'FETCHED'
        ? props.currentProject.project.id
        : undefined;
    var status = props.notificationsOptionsOverlayStatus.type === 'OPEN'
        ? props.notificationsOptionsOverlayStatus.status
        : 'STANDBY';
    var sortByOptions = props.sortByOptions;
    var searchOptions = props.searchOptions;
    return {
        projectName: projectName,
        files: props.notificationsOptionsOverlayStatus.type !== 'CLOSED'
            ? props.notificationsOptionsOverlayStatus.files
            : [],
        currentFolder: props.currentFolder,
        status: status,
        type: props.notificationsOptionsOverlayStatus.type,
        sortByOptions: sortByOptions,
        searchOptions: searchOptions,
        projectId: projectId,
        closeAndClear: props.closeAndClear,
        user: props.user.toNullable(),
        save: props.save,
        toggleEmailNotifications: props.toggleEmailNotifications
    };
};
var mappedPropsExtractable = Types.extractReturnType(reMappedState);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.mapProps)(reMappedState), recompose_1.pure);
exports.FileNotificationsOptionsOverlay = enhance(function (props) {
    return (React.createElement(sok_ui_1.Overlay, { isOpen: props.type === 'OPEN', onClose: props.closeAndClear(props.currentFolder ? props.currentFolder.id : undefined, props.sortByOptions, props.searchOptions) },
        React.createElement(sok_ui_1.SideMenu, { className: 'sok-file-notifications', isOpen: props.type === 'OPEN', docked: false, orientation: 'right' }, (function () {
            if (props.type === 'CLOSED')
                return React.createElement("div", null);
            var name = props.files.map(function (x) { return x.name; }).join(', ');
            var email = props.files.every(function (x) {
                return x.notifications ? x.notifications.email : false;
            });
            return (React.createElement(React.Fragment, null,
                React.createElement(sok_ui_1.Header, { onClose: props.closeAndClear(props.currentFolder ? props.currentFolder.id : undefined, props.sortByOptions, props.searchOptions) }, (0, translation_1.getLocalization)('userfront/project/files/FileNotificationsOptionsOverlay/FolderNotificationsTitle')),
                React.createElement(sok_ui_1.RequestStatusBox, { status: props.status, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
                    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/FilesFolderPropertiesOverlay/saving')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/FilesFolderPropertiesOverlay/successSaving')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/FilesFolderPropertiesOverlay/successFailed'))),
                React.createElement(sok_ui_1.Container, null,
                    React.createElement("div", { className: "sok-file-notification-content" },
                        React.createElement("div", { className: "sok-file-notification-body" },
                            React.createElement("h2", null, (0, translation_1.getLocalization)('userfront/project/files/FileNotificationsOptionsOverlay/defineNotificationsTitle')),
                            React.createElement("p", null,
                                (0, translation_1.getLocalization)('userfront/project/files/FileNotificationsOptionsOverlay/getNotificationsFrom'),
                                ' ',
                                React.createElement("b", null, name),
                                ' ',
                                (0, translation_1.getLocalization)('userfront/project/files/FileNotificationsOptionsOverlay/in'),
                                ' ',
                                React.createElement("b", null, props.projectName),
                                "."),
                            React.createElement(sok_ui_1.Input, { type: "checkbox", label: (0, translation_1.getLocalization)('userfront/project/files/FileNotificationsOptionsOverlay/sendEmailNotifications'), name: "email", disabled: false, value: email, onChange: function () {
                                    return props.toggleEmailNotifications(props.files)(!email);
                                } }),
                            React.createElement("p", null,
                                React.createElement("i", null, (0, translation_1.getLocalization)('userfront/project/files/FileNotificationsOptionsOverlay/notifyMeWhenSomeoneUploadsToThisFolder')))))),
                React.createElement(sok_ui_1.Footer, null,
                    React.createElement(sok_ui_1.Button, { color: "green", disabled: props.status === 'SAVING', onClick: function () {
                            return props.user && props.save(props.files, email, 'EMAIL');
                        }, text: (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/save') }),
                    React.createElement(sok_ui_1.Button, { color: 'dark-gray', disabled: props.status === 'SAVING', onClick: props.closeAndClear(props.currentFolder ? props.currentFolder.id : undefined, props.sortByOptions, props.searchOptions), text: (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/cancel') }))));
        })())));
});
